import axios from './index'
import prefix_ms from './prefix'
// /user/qrcode/recognize
// 识别用户二维码
export const getRecognize = (params) => {
    return axios.request({
      url: `${prefix_ms}/userRelation/code/recognize`,
      method: 'get',
      params: params,
    })
  }
  
  // /user/bind
  // 亲子关系绑定
  export const postBind = (params) => {
    return axios.request({
      url: `${prefix_ms}/userRelation/bind`,
      method: 'post',
      data: params,
    })
  }
  
  // /user/family
  // 获取亲子列表
  export const getFamily = (params) => {
    return axios.request({
      url: `${prefix_ms}/userRelation/family`,
      method: 'get',
      params: params,
    })
  }
  
  // /user/unbind/{childId}
  // 家长解绑
  export const postUnbind = (childId) => {
    return axios.request({
      url: `${prefix_ms}/userRelation/unbind/${childId}`,
      method: 'post',
    })
  }


//////////////////
// WEBPACK FOOTER
// ./app/api/family.js
// module id = null
// module chunks = 